// Go-Forward User Roles
export const EMPLOYEE = 'employee';
export const EMPLOYER = 'employer';
export const EMPLOYER_ADMIN = 'employeradmin';
export const BROKER = 'broker';
export const VENDOR = 'vendor';
export const INTERNAL = 'internal';
// Legacy Internal Roles
export const CLIENT_SERVICE_REP = 'clientservicerep';
export const CLIENT_SERVICE_REPS = 'client_service_reps';
export const CLIENT_SERVICE_REP_OLD = 'gb_ecr_group_role_client_service_rep';
export const SUPER_ADMIN = 'super_admin';
export const SUPER_USER = 'superuser';
export const INTERNAL_ADMIN = 'internal_admin';
export const SERVICE_REGION_EAST = 'service_region_east';
export const SERVICE_REGION_WEST = 'service_region_west';
export const SERVICE_REGION_CENTRAL = 'service_region_central';
export const INSTALLATION_SUPPORT = 'installation_support';
export const PT_REPORTING = 'pt_reporting';
export const GMHO = 'gmho';
export const CONTENT_MANAGERS = 'content_managers';
export const LIFE_BENEFICIARY_MANAGERS = 'life_beneficiery_managers';
// Display labels for the go-forward roles shown in the ER User Access list.
const ROLE_DISPLAY_NAMES = {
    [EMPLOYER]: 'Employer',
    [EMPLOYER_ADMIN]: 'Employer Admin',
    [BROKER]: 'Broker',
    [VENDOR]: 'Vendor',
};
// Title-cases an unmapped role code as a sensible fallback (e.g. "some_role" -> "Some Role").
const titleCaseRole = (role) => role
    .split(/[\s_]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
// Maps a single role code to its display label, falling back to title case for unknown roles.
export const formatRoleName = (role) => {
    if (!role) {
        return '';
    }
    const normalized = role.toLowerCase();
    return ROLE_DISPLAY_NAMES[normalized] ?? titleCaseRole(normalized);
};
// Formats a user's roles for display: each mapped to its display label (title-cased fallback), comma-separated (e.g. "Broker, Employer").
// The base "employee" role is omitted to match the user report, which never lists it as a role.
export const formatRoleNames = (roleNames) => (roleNames ?? [])
    .filter(Boolean)
    .filter(role => role.toLowerCase() !== EMPLOYEE)
    .map(formatRoleName)
    .join(', ');
// True when a user holds the Employer Admin role. Employer Admin accounts cannot be
// modified, removed, or copied to/from, so their user-list rows are non-interactive.
export const isEmployerAdmin = (roleNames) => (roleNames ?? []).some(role => role?.toLowerCase() === EMPLOYER_ADMIN);
